import logo from 'assets/img/logo.png'
import EnvBadge from 'components/envBadge'
import { Outlet } from 'react-router-dom'

const LogoLayout = () => {
  return (
    <>
      <header className="flex h-16 items-center justify-between px-10 py-3">
        <div className="w-28 shrink-0">
          <img
            src={logo}
            alt="gag-logo"
            className="h-full w-full object-contain"
          />
        </div>
        <EnvBadge />
      </header>
      <main>
        <Outlet />
      </main>
    </>
  )
}

export default LogoLayout
